import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../utils/apiConfig';

export default function CatalogVendorSuggestions({ query, token, onSelect, disabled = false }) {
  const [vendors, setVendors] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setVendors([]); setError(''); setLoading(false);
    if (!token || query.trim().length < 2) return;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/orders/pos/catalog-vendors?q=${encodeURIComponent(query.trim())}`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Unable to search catalog vendors.');
        if (!controller.signal.aborted) { setVendors(data.vendors || []); if (!data.vendors?.length) setError('No matching catalog vendor.'); }
      } catch (err) { if (!controller.signal.aborted) setError(err.message); }
      finally { if (!controller.signal.aborted) setLoading(false); }
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [query, token]);
  return <div className="text-sm">
    {loading && <p role="status">Searching vendors…</p>}
    {error && <p className="text-amber-700">{error}</p>}
    {!!vendors.length && <div className="max-h-40 overflow-auto rounded border bg-white" aria-label="Catalog vendor suggestions">{vendors.map(vendor => {
      const validPhone = /^\d{10}$/.test(vendor.phoneNo || '');
      return <button key={vendor.id} type="button" disabled={disabled || !validPhone} onClick={() => onSelect(vendor)} className="block w-full border-b px-3 py-2 text-left hover:bg-amber-50 disabled:cursor-not-allowed disabled:bg-gray-50"><strong>{vendor.name}</strong> · {validPhone ? vendor.phoneNo : 'Mobile missing in catalog'}{!validPhone && <span className="block text-xs text-amber-700">Add a valid mobile in the vendor catalog before billing.</span>}</button>;
    })}</div>}
  </div>;
}
